import styled from "styled-components";
import DealerFundingRequestSuccess from "./DealerFundingRequestSuccess";
import breakpoints from "../../../theme/breakpoints";

export const StyledDealerFundingRequestSuccess = styled(
  DealerFundingRequestSuccess
)`
  background-color: ${(props) => props.theme.COLOURS.WHITE};
  height: 100%;
  display: flex;
  flex-direction: column;

  //align the modal actions at the bottom of the page
  &:last-child {
    align-self: flex-end;
  }

  @media (min-width: ${breakpoints.LARGE_DESKTOP}) {
    box-sizing: border-box;
    border: 0.2rem solid ${(props) => props.theme.COLOURS.ACCENT.base};
    padding: ${(props) => props.theme.SPACING.MEDIUM};
    border-radius: 0.9rem;
    width: 100%;
  }

  .header {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    margin-top: ${(props) => props.theme.SPACING.REGULAR};

    @media (min-width: ${breakpoints.LARGE_DESKTOP}) {
      margin-top: 0;
      flex-direction: row-reverse;
      margin-bottom: ${(props) => props.theme.SPACING.REGULAR};
    }

    > span {
      margin-left: ${(props) => props.theme.SPACING.SMALL};
    }
  }

  .modal-content {
    display: flex;
    flex-direction: column;
    margin-top: ${(props) => props.theme.SPACING.SMALL};

    .row {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: ${(props) => props.theme.SPACING.SMALL};

      @media (min-width: ${breakpoints.PHONE}) {
        flex-direction: row;
        align-items: center;
        margin-top: ${(props) => props.theme.SPACING.SMALL};
        > p:last-child {
          margin-left: ${(props) => props.theme.SPACING.SMALL};
        }
      }
    }
  }
`;

export default StyledDealerFundingRequestSuccess;
